import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import { api } from "../../api/apiService";

const AdminUpdateAttendance = ({ show, onClose, employee, employeeId, onAttendanceUpdated }) => {
    const [status, setStatus] = useState("");
    const [attendCount, setAttendCount] = useState("");
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (show) {
            setStatus("");
            setAttendCount("");
        }
    }, [show]);

    const handleSave = async () => {
        const formattedDate = moment(employee.date, "DD-MM-YYYY").format("YYYY-MM-DD");
        const payload = {
            employee_id: employeeId,
            date: formattedDate,
            type: status,
            attend_count: status === "absent" ? 0 : attendCount
        };

        try {
            setIsSaving(true);
            await api.post("/admin/update-attendance", payload);
            toast.success("Attendance status updated successfully!");
            onClose();
            if (onAttendanceUpdated) {
                onAttendanceUpdated();
            }
        } catch (error) {
            if (error.data && error.data.errors) {
                error.data.errors.forEach(err => {
                    toast.error(err);
                });
            } else {
                toast.error("Failed to update attendance status");
            }
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                {/* <Modal.Title>Update Attendance</Modal.Title> */}
                <h5 className="modal-title text-dark">Update Attendance</h5>
            </Modal.Header>
            <Modal.Body>
                {employee ? (
                    <>
                        <span className="text-dark">{employee.date}</span>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold text-dark">Select Status</label>
                                <div className="d-flex justify-content-between">
                                    <div className="form-check">
                                        <input
                                            type="radio"
                                            className="form-check-input"
                                            id="present"
                                            name="attendanceStatus"
                                            value="present"
                                            checked={status === "present"}
                                            onChange={(e) => setStatus(e.target.value)}
                                        />
                                        <label className="form-check-label" htmlFor="present">Present</label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            type="radio"
                                            className="form-check-input"
                                            id="absent"
                                            name="attendanceStatus"
                                            value="absent"
                                            checked={status === "absent"}
                                            onChange={(e) => setStatus(e.target.value)}
                                        />
                                        <label className="form-check-label" htmlFor="absent">Absent</label>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                {status !== "absent" && (
                                    <>
                                        <label className="form-label fw-bold text-dark">Attendance Count</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={attendCount}
                                            onChange={(e) => setAttendCount(e.target.value)}
                                        />
                                    </>
                                )}
                            </div>
                        </div>
                    </>
                ) : (
                    <p>No employee selected.</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose} disabled={isSaving}>
                    Close
                </Button>
                <Button
                    variant="primary"
                    onClick={handleSave}
                    disabled={isSaving || !status}
                >
                    {isSaving ? "Saving..." : "Save"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AdminUpdateAttendance;